import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Navbar from '../student/Navbar';
import ITSidebar from './ITSidebar';
import Loader from '../components/Loader';
import { motion } from 'framer-motion';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import {
  FaUserAlt,
  FaUsers,
  FaUserGraduate,
  FaUserMd,
  FaUserNurse,
  FaPlus,
  FaChartLine,
  FaCog,
  FaEye,
  FaEdit,
  FaTrash,
  FaSearch,
  FaFilter,
  FaDownload,
  FaUpload,
  FaCheck,
  FaTimes,
  FaExclamationTriangle,
  FaInfoCircle,
  FaUserPlus,
  FaFileExcel,
  FaFileCsv,
  FaSync,
  FaBell,
  FaShieldAlt,
  FaDatabase,
  FaServer,
  FaNetworkWired,
  FaLock,
  FaUnlock,
  FaKey,
  FaUserLock,
  FaUserCheck,
  FaUserTimes,
  FaBan,
  FaCheckCircle,
  FaExclamationCircle,
  FaQuestionCircle,
  FaCog as FaSettings,
  FaChartBar,
  FaTable,
  FaList,
  FaTh,
  FaThList,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaExpand,
  FaCompress,
  FaCopy,
  FaClipboard,
  FaPrint,
  FaShare,
  FaExternalLinkAlt,
  FaArrowLeft,
  FaArrowRight,
  FaArrowUp,
  FaArrowDown,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaChevronDown,
  FaMinus,
  FaEquals,
  FaPercentage,
  FaCalculator,
  FaClock,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarCheck,
  FaCalendarTimes,
  FaHistory,
  FaUndo,
  FaRedo,
  FaSave,
  FaTimesCircle,
  FaCheckSquare,
  FaSquare,
  FaCircle,
  FaDotCircle,
  FaStop,
  FaPlay,
  FaPause,
  FaStopCircle,
  FaPlayCircle,
  FaPauseCircle,
  FaForward,
  FaBackward,
  FaStepForward,
  FaStepBackward,
  FaFastForward,
  FaFastBackward,
  FaRandom,
  FaRepeat,
  FaRedoAlt,
  FaUndoAlt,
  FaSyncAlt,
  FaSpinner,
  FaCircleNotch,
  FaHourglassHalf,
  FaHourglassStart,
  FaHourglassEnd,
  FaHourglass,
  FaStopwatch,
  FaClock as FaTime,
  FaCalendarDay,
  FaCalendarWeek,
  FaCalendarMonth,
  FaCalendarYear,
  FaCalendarPlus,
  FaCalendarMinus,
  FaCalendarEdit,
  FaCalendarX,
  FaCalendarAlt as FaCalendarAltIcon,
  FaCalendarCheck as FaCalendarCheckIcon,
  FaCalendarTimes as FaCalendarTimesIcon,
  FaCalendarDay as FaCalendarDayIcon,
  FaCalendarWeek as FaCalendarWeekIcon,
  FaCalendarMonth as FaCalendarMonthIcon,
  FaCalendarYear as FaCalendarYearIcon,
  FaCalendarPlus as FaCalendarPlusIcon,
  FaCalendarMinus as FaCalendarMinusIcon,
  FaCalendarEdit as FaCalendarEditIcon,
  FaCalendarX as FaCalendarXIcon
} from 'react-icons/fa';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement
);

// Website color palette
const websiteColorPalette = {
  primary: '#0077B6',
  secondary: '#20B2AA',
  background: '#FFFFFF',
  text: '#333333',
  accent: '#28A745'
};

const ITDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [roleFilter, setRoleFilter] = useState('all');
  const [stats, setStats] = useState({
    total: 0,
    byRole: {
      students: 0,
      admins: 0,
      supervisors: 0,
      assistants: 0,
      dentists: 0,
      its: 0
    },
    recentActivity: 0,
    systemHealth: 'good'
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [chartData, setChartData] = useState({
    userActivity: {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      datasets: [{
        label: 'Active Users',
        data: [12, 19, 3, 5, 2, 3, 8],
        backgroundColor: 'rgba(0, 119, 182, 0.8)',
        borderColor: 'rgba(0, 119, 182, 1)',
        borderWidth: 1
      }]
    },
    roleDistribution: {
      labels: ['Students', 'Admins', 'Supervisors', 'Assistants', 'Dentists', 'IT'],
      datasets: [{
        data: [45, 12, 8, 15, 10, 5],
        backgroundColor: [
          'rgba(34, 197, 94, 0.8)',
          'rgba(147, 51, 234, 0.8)',
          'rgba(59, 130, 246, 0.8)',
          'rgba(245, 158, 11, 0.8)',
          'rgba(239, 68, 68, 0.8)',
          'rgba(249, 115, 22, 0.8)'
        ],
        borderColor: [
          'rgba(34, 197, 94, 1)',
          'rgba(147, 51, 234, 1)',
          'rgba(59, 130, 246, 1)',
          'rgba(245, 158, 11, 1)',
          'rgba(239, 68, 68, 1)',
          'rgba(249, 115, 22, 1)'
        ],
        borderWidth: 2
      }]
    }
  });
  
  // Notifications
  const [showNotifications, setShowNotifications] = useState(false);
  
  
  // Notifications
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  
  // System status
  const [systemStatus, setSystemStatus] = useState({
    database: 'online',
    api: 'online',
    storage: 'online',
    lastBackup: new Date().toISOString()
  });
  
  const navigate = useNavigate();
  const { user, token } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      if (!user || !token) {
        setError('Please log in to view your dashboard.');
        setLoading(false);
        return;
      }

      if (!user.university) {
        setError('User profile incomplete. Missing university information.');
        setLoading(false);
        return;
      }

      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };

        // Fetch stats only
        const statsRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/it/stats`, config);
        setStats(statsRes.data);

        // Update chart data with real stats
        setChartData(prev => ({
          ...prev,
          roleDistribution: {
            ...prev.roleDistribution,
            datasets: [{
              ...prev.roleDistribution.datasets[0],
              data: [
                statsRes.data.byRole?.students || 0,
                statsRes.data.byRole?.admins || 0,
                statsRes.data.byRole?.supervisors || 0,
                statsRes.data.byRole?.assistants || 0,
                statsRes.data.byRole?.dentists || 0,
                statsRes.data.byRole?.its || 0
              ]
            }]
          }
        }));

      } catch (err) {
        const errorMessage =
          err.response?.status === 404
            ? 'Data endpoint not found.'
            : err.response?.status === 401
            ? 'Unauthorized. Please log in again.'
            : err.response?.data?.message || 'Failed to load data';
        setError(errorMessage);
        if (err.response?.status === 401) navigate('/login');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user, token, navigate]);

  // Chart configuration
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'User Activity Over Time'
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: 'User Role Distribution'
      }
    }
  };


  // Utility functions
  const fetchData = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const statsRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/it/stats`, config);
      
      // Update stats with real data from backend
      const backendStats = statsRes.data;
      setStats({
        total: backendStats.total || 0,
        byRole: {
          students: backendStats.byRole?.students || 0,
          admins: backendStats.byRole?.admins || 0,
          supervisors: backendStats.byRole?.supervisors || 0,
          assistants: backendStats.byRole?.assistants || 0,
          dentists: backendStats.byRole?.dentists || 0,
          its: backendStats.byRole?.its || 0
        },
        recentActivity: 0,
        systemHealth: {
          database: 'healthy',
          api: 'healthy',
          storage: 'healthy',
          lastBackup: new Date().toISOString()
        }
      });

      // Update chart data with real stats
      setChartData(prev => ({
        ...prev,
        roleDistribution: {
          ...prev.roleDistribution,
          datasets: [{
            ...prev.roleDistribution.datasets[0],
            data: [
              backendStats.byRole?.students || 0,
              backendStats.byRole?.admins || 0,
              backendStats.byRole?.supervisors || 0,
              backendStats.byRole?.assistants || 0,
              backendStats.byRole?.dentists || 0,
              backendStats.byRole?.its || 0
            ]
          }]
        }
      }));
    } catch (err) {
      console.error('Error fetching data:', err);
      setError('Failed to load data');
    }
  };

  const refreshData = async () => {
    setLoading(true);
    await fetchData();
    setLoading(false);
  };

  const container = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  if (loading) return <Loader />;

  return (
    <div className="flex h-screen bg-gray-50">
      <ITSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 bg-gradient-to-br from-blue-50 to-white">
          <div className="max-w-7xl mx-auto">
            {/* Notifications */}
            {error && (
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded-lg shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <FaExclamationCircle className="w-5 h-5 text-red-500 mr-3" />
                    <p className="text-red-700 font-medium">{error}</p>
                  </div>
                  <button onClick={() => setError('')} className="text-red-500 hover:text-red-700">
                    <FaTimes />
                  </button>
                </div>
              </motion.div>
            )}
            
            {success && (
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 rounded-lg shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <FaCheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <p className="text-green-700 font-medium">{success}</p>
                  </div>
                  <button onClick={() => setSuccess('')} className="text-green-500 hover:text-green-700">
                    <FaTimes />
                  </button>
                </div>
              </motion.div>
            )}
            
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
              {/* Header with Actions */}
              <div className="mb-6 sm:mb-8">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
                  <div>
                    <h1 className={`text-2xl sm:text-3xl md:text-4xl font-bold text-[${websiteColorPalette.primary}] mb-1`}>IT Dashboard</h1>
                    <p className={`text-[${websiteColorPalette.text}]`}>Welcome back, {user?.name || 'IT Admin'}</p>
                    <p className="text-sm text-gray-600">University: {user?.university || 'N/A'}</p>
                  </div>
                  
                  <div className="flex flex-wrap gap-2 mt-4 sm:mt-0">
                    <button
                      onClick={refreshData}
                      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center"
                    >
                      <FaSync className="h-4 w-4 mr-2" />
                      Refresh
                    </button>
                  </div>
                </div>
                
                {/* System Status */}
                <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-100">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-lg font-semibold text-gray-800">System Status</h3>
                    <div className="flex items-center">
                      <div className={`w-2 h-2 rounded-full mr-2 ${systemStatus.database === 'online' ? 'bg-green-500' : 'bg-red-500'}`}></div>
                      <span className="text-sm text-gray-600">All Systems Operational</span>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
                    <div className="flex items-center">
                      <FaDatabase className="h-4 w-4 text-green-500 mr-2" />
                      <span>Database: {systemStatus.database}</span>
                    </div>
                    <div className="flex items-center">
                      <FaServer className="h-4 w-4 text-green-500 mr-2" />
                      <span>API: {systemStatus.api}</span>
                    </div>
                    <div className="flex items-center">
                      <FaNetworkWired className="h-4 w-4 text-green-500 mr-2" />
                      <span>Storage: {systemStatus.storage}</span>
                    </div>
                    <div className="flex items-center">
                      <FaClock className="h-4 w-4 text-gray-500 mr-2" />
                      <span>Last Backup: {new Date(systemStatus.lastBackup).toLocaleDateString()}</span>
                    </div>
                  </div>
                </div>
              </div>

              <motion.div
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="space-y-6 sm:space-y-8"
              >
                {/* Enhanced Stats Cards */}
                <motion.div
                  variants={container}
                  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6"
                >
                  <motion.div
                    variants={item}
                    className="bg-white p-4 sm:p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 cursor-pointer"
                    onClick={() => setRoleFilter('all')}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="bg-blue-50 w-12 h-12 sm:w-14 sm:h-14 rounded-lg flex items-center justify-center mr-3 sm:mr-4">
                          <FaUsers className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600" />
                        </div>
                        <div>
                          <p className="text-xs sm:text-sm font-medium text-gray-600">Total Accounts</p>
                          <p className="text-xl sm:text-2xl font-bold text-blue-600">{stats.total}</p>
                          <p className="text-xs text-gray-500">All Users</p>
                        </div>
                      </div>
                      <FaChevronRight className="h-4 w-4 text-gray-400" />
                    </div>
                  </motion.div>

                  <motion.div
                    variants={item}
                    className="bg-white p-4 sm:p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 cursor-pointer"
                    onClick={() => setRoleFilter('student')}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="bg-green-50 w-12 h-12 sm:w-14 sm:h-14 rounded-lg flex items-center justify-center mr-3 sm:mr-4">
                          <FaUserGraduate className="h-5 w-5 sm:h-6 sm:w-6 text-green-600" />
                        </div>
                        <div>
                          <p className="text-xs sm:text-sm font-medium text-gray-600">Students</p>
                          <p className="text-xl sm:text-2xl font-bold text-green-600">{stats.byRole.students}</p>
                          <p className="text-xs text-gray-500">Active</p>
                        </div>
                      </div>
                      <FaChevronRight className="h-4 w-4 text-gray-400" />
                    </div>
                  </motion.div>

                  <motion.div
                    variants={item}
                    className="bg-white p-4 sm:p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 cursor-pointer"
                    onClick={() => setRoleFilter('admin')}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="bg-purple-50 w-12 h-12 sm:w-14 sm:h-14 rounded-lg flex items-center justify-center mr-3 sm:mr-4">
                          <FaUserMd className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600" />
                        </div>
                        <div>
                          <p className="text-xs sm:text-sm font-medium text-gray-600">Staff</p>
                          <p className="text-xl sm:text-2xl font-bold text-purple-600">{stats.byRole.admins + stats.byRole.supervisors + stats.byRole.assistants}</p>
                          <p className="text-xs text-gray-500">Admins & Staff</p>
                        </div>
                      </div>
                      <FaChevronRight className="h-4 w-4 text-gray-400" />
                    </div>
                  </motion.div>

                  <motion.div
                    variants={item}
                    className="bg-white p-4 sm:p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 cursor-pointer"
                    onClick={() => setRoleFilter('it')}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="bg-orange-50 w-12 h-12 sm:w-14 sm:h-14 rounded-lg flex items-center justify-center mr-3 sm:mr-4">
                          <FaShieldAlt className="h-5 w-5 sm:h-6 sm:w-6 text-orange-600" />
                        </div>
                        <div>
                          <p className="text-xs sm:text-sm font-medium text-gray-600">IT Accounts</p>
                          <p className="text-xl sm:text-2xl font-bold text-orange-600">{stats.byRole.its}</p>
                          <p className="text-xs text-gray-500">System Ready</p>
                        </div>
                      </div>
                      <FaChevronRight className="h-4 w-4 text-gray-400" />
                    </div>
                  </motion.div>
                </motion.div>

                {/* Analytics Charts Section */}
                <motion.div
                  variants={item}
                  className="grid grid-cols-1 lg:grid-cols-2 gap-6"
                >
                  {/* User Activity Chart */}
                  <motion.div
                    variants={item}
                    className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 p-6"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h2 className={`text-lg font-bold text-[${websiteColorPalette.primary}] flex items-center`}>
                        <FaChartLine className="h-5 w-5 mr-2" />
                        User Activity
                      </h2>
                    </div>
                    <div className="h-80">
                      <Bar data={chartData.userActivity} options={chartOptions} />
                    </div>
                  </motion.div>

                  {/* Role Distribution Chart */}
                  <motion.div
                    variants={item}
                    className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 p-6"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h2 className={`text-lg font-bold text-[${websiteColorPalette.primary}] flex items-center`}>
                        <FaChartBar className="h-5 w-5 mr-2" />
                        Role Distribution
                      </h2>
                    </div>
                    <div className="h-80">
                      <Doughnut data={chartData.roleDistribution} options={doughnutOptions} />
                    </div>
                  </motion.div>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>
        </main>
      </div>


    </div>
  );
};

export default ITDashboard;
